import { css } from 'emotion';

export const profilePictureStyle = (size, sizesAt) =>
	css({
		background: '#D8D8D8',
		width: size,
		height: size,
		borderRadius: size / 2,
		position: 'relative',
		'& img': {
			position: 'absolute',
			top: '0',
			left: '0',
			width: size,
			height: size,
			clipPath: `circle(${size / 2}px at center)`,
		},
		...(sizesAt
			? Object.assign(
					...Object.keys(sizesAt).map(c => {
						const key = c.indexOf('media') === -1 ? `@media (max-width: ${c}px)` : c;

						return {
							[key]: {
								width: sizesAt[c],
								height: sizesAt[c],
								borderRadius: sizesAt[c] / 2,
								'& > img': {
									width: sizesAt[c],
									height: sizesAt[c],
									clipPath: `circle(${sizesAt[c] / 2}px at center)`,
								},
							},
						};
					})
			  )
			: null),
	});



// WEBPACK FOOTER //
// ./src/components/support-organisations/profilePicture/styles.js